import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class GenericUtils {

    public isPath(path: string, pathToCheck: string): boolean {
        return path.includes(pathToCheck);
    }

    public b64toBlob(base64: string): Blob {

        const byteString = atob(base64.split(",")[1]);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);

        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([
            ab
        ], { type: "image/png" });
    }
}
